import type { Release } from '../releases';

export default {
  id: '2026-11-01-payment-registry',
  at: '2026-11-01T06:22:00Z',
  title: 'Реестр платежей на утверждение — с телефона',
  modules: ['finance'],
  items: [
    'В «Финансах» появилась вкладка «Реестр платежей»: финансист собирает на день оплаты заявки, уже переданные на оплату, с отбором по проекту, сроку и сумме.',
    'Заявка входит в реестр, только если договор подписан, статья есть в утверждённом финансовом плане проекта, платёж стоит в графике договора (а значит, в ДДС) и заявка передана на оплату с документами. Что мешает — написано прямо в строке.',
    'Финансовый менеджер утверждает реестр с телефона — это делает не тот, кто его собирал; может исключить отдельные заявки с причиной или вернуть реестр. Реестр на утверждении появляется у него в «Ждёт меня».',
    'Утверждённый реестр выгружается в 1С и файлом для клиент-банка; в карточке видно, когда это сделали.',
  ],
  why: 'Оплаты шли по одной заявке без общего утверждения на день, а проверить, что платёж есть в финансовом плане и в ДДС, можно было только вручную.',
  link: '/finance?tab=registry',
} satisfies Release;
